import { AxiosResponse } from "axios";
import { JobFolderGroupedOrderAndQuote } from "Models/file";
import BaseService from "./_base.service";
import API from "../api";
import { Folder } from "Models/folder";

const ROUTE_NAME = "folders";

const FolderService = {
  ...BaseService<Folder>({ endpoint: ROUTE_NAME }),

  async getOrderFolders(id?: number): Promise<AxiosResponse<Folder[]>> {
    return await API.get(`/${ROUTE_NAME}/job/${id}/by?type=order`);
  },
  async getQuoteFolders(id?: number): Promise<AxiosResponse<Folder[]>> {
    return await API.get(`/${ROUTE_NAME}/job/${id}/by?type=quote`);
  },
  async createUpdateFolder(
    jobId: number,
    folders: Folder[],
    companyId: number,
    foldersDeleted?: Folder[],
    filesDeleted?: Folder[]
  ): Promise<AxiosResponse<Folder[]>> {
    return await API.post(`/${ROUTE_NAME}/job`, {
      jobId,
      folders,
      foldersDeleted,
      filesDeleted,
      companyId,
    });
  },
};

export default FolderService;
